module.exports = __webpack_public_path__ + "img/e_1_1_g.a05b647c.png";